import axiosInstance from './interceptor';

class ApiService {
  /**
   * GET request
   * @param {string} url - relative path (e.g. '/api/admin/programs')
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<T>}
   */
  async get(url, config) {
    const response = await axiosInstance.get(url, config);
    return response.data;
  }

  /**
   * POST request
   * @param {string} url
   * @param {*} [data]
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<T>}
   */
  async post(url, data, config) {
    const response = await axiosInstance.post(url, data, config);
    return response.data;
  }

  /**
   * PUT request
   * @param {string} url
   * @param {*} [data]
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<T>}
   */
  async put(url, data, config) {
    const response = await axiosInstance.put(url, data, config);
    return response.data;
  }

  /**
   * PATCH request
   * @param {string} url
   * @param {*} [data]
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<T>}
   */
  async patch(url, data, config) {
    const response = await axiosInstance.patch(url, data, config);
    return response.data;
  }

  /**
   * DELETE request
   * @param {string} url
   * @param {import('axios').AxiosRequestConfig} [config]
   * @returns {Promise<T>}
   */
  async delete(url, config) {
    const response = await axiosInstance.delete(url, config);
    return response.data;
  }
}

const apiService = new ApiService();
export default apiService;
